import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import AdminLayout from "./components/Layout/AdminLayout";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import DispatchProducts from "./pages/admin/DispatchProducts";
import WarehouseProducts from "./pages/admin/WarehouseProducts";
import CheckList from "./pages/admin/CheckList";
import UserSettings from "./pages/admin/UserSettings";
import CompanyManagement from "./pages/admin/CompanyManagement";
import { useEffect } from "react";
import {useThemeStore} from "./store/themeStore"
import NotFound from "./pages/NotFound";
import SysCheckList from "./pages/admin/sysAdmin/SysCheckList"; 
import SysWarehouseProducts from "./pages/admin/sysAdmin/SysWarehouseProducts";
import ContactInfo from "./pages/admin/ContactInfo";
import SysDispatchProducts from "./pages/admin/sysAdmin/SysDispatchProducts";
import Dashboard from "./pages/admin/Dashboard";
import AccountPage from "./pages/admin/AccountPage";

const queryClient = new QueryClient();
function App() {
  const { theme } = useThemeStore(); // Tema durumu

  useEffect(() => {
    // Mevcut tema dosyasını kaldırma
    const existingThemeLink = document.getElementById('theme-link');
    if (existingThemeLink) {
      existingThemeLink.remove();
    }

    // Tema değişiminde ilgili CSS dosyasını dinamik olarak import ediyoruz
    const themeLink = document.createElement('link');
    themeLink.id = 'theme-link';
    themeLink.rel = 'stylesheet';
    if (theme === 'dark') {
      themeLink.href = 'https://unpkg.com/primereact/resources/themes/lara-dark-blue/theme.css'; // Dark tema
    } else {
      themeLink.href = 'https://unpkg.com/primereact/resources/themes/lara-light-blue/theme.css'; // Light tema
    } 
    document.head.appendChild(themeLink); // Tema linkini head'e ekliyoruz
  }, [theme]); // Tema değiştikçe çalışacak

  return (
    <QueryClientProvider client={queryClient}> 
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="dispatch" element={<DispatchProducts />} />
            <Route path="warehouse" element={<WarehouseProducts />} />
            <Route path="checklist" element={<CheckList />} />
            <Route path="users" element={<UserSettings />} />
            <Route path="companies" element={<CompanyManagement />} />
            <Route path="syschecklist" element={<SysCheckList />} />
            <Route path="sysdispatch" element={<SysDispatchProducts />} />
            <Route path="syswarehouse" element={<SysWarehouseProducts />} />
            <Route path="contact" element={<ContactInfo />} />
            <Route path="account" element={<AccountPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </QueryClientProvider>
  );
}

export default App;
